import Component from "./component"
import Header from "./header"

// sensitivityType travels with the template (the selected template already encodes predicted vs
// historical); GraphWrapper forwards it to the header/chart.
export const historical = {
  Component,
  Header,
  sensitivityType: "historical" as const,
}

export const predicted = {
  Component,
  Header,
  sensitivityType: "predicted" as const,
}
